export default __webpack_public_path__ + "static/media/modal-inquilino-curitiba.79363a1c.webp";